module.exports = __webpack_public_path__ + "img/C05TechBellumRomanum_ua.797a5de5.webp";